import { render, staticRenderFns } from "./XMenu.vue?vue&type=template&id=f3d74d3c&scoped=true"
import script from "./XMenu.vue?vue&type=script&lang=js"
export * from "./XMenu.vue?vue&type=script&lang=js"
import style0 from "./XMenu.vue?vue&type=style&index=0&id=f3d74d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d74d3c",
  null
  
)

export default component.exports